import React from 'react';
import {connect} from 'react-redux';
import * as s from './selectors';
import * as a from './actions';
import './reducers';

const ConfiguratorTabs = connect(
    null,
    (dispatch) => ({
        selectTab: (tab) => () => dispatch(a.selectTab(tab))
    })
)(({tabs, selectTab}) => {
    return (
        <div className="menu-configurator__tabs">
            {tabs.map((tab) => {
                return <span key={tab.id} onClick={selectTab(tab)} className={`menu-configurator__tab${tab.selected ? " menu-configurator__tab--selected" : ""}`}>{tab.title}</span>
            })}
        </div>
    );
});

const MenuItem = connect(
    null,
    (dispatch, {item}) => ({
        selectItem: () => {
            if (item.disabled) {
                return; // ignore adding disabled product
            }

            dispatch(a.selectItem(item));
        }
    })
)(({item, selectItem}) => {
    const price = item.price ? <span className="menu-configurator__item_price">{item.price}</span> : null;
    return (
        <div onClick={selectItem} className={`menu-configurator__item ${item.disabled ? "menu-configurator__item--disabled" : ""} ${item.selected ? "menu-configurator__item--selected" : ""}`}>
            <picture>
                <source srcset={item.imgDesktop} media="(min-width:1200px)" className="menu-configurator__item-img bg-light" />
                <img src={item.imgMobile} className="menu-configurator__item-img bg-light" alt={item.description} />
            </picture>
            {price}
            <span className="menu-configurator__item-description">{item.description}</span>
        </div>
    );
});

export const MenuConfigurator = connect(
    (state) => ({
        staticTexts: s.staticTexts(state),
        menuDescription: s.menuDescription(state),
        tabs: s.visibleTabs(state),
        items: s.items(state),
        canFinish: s.canFinish(state),
        finished: s.finished(state)
    }),
    (dispatch) => ({
        finishConfiguration: () => dispatch(a.finishConfiguration())
    })
)(({
    staticTexts, tabs, menuDescription, items, finishConfiguration, finished, canFinish
}) => {
    if (finished) {
        return (
            <div className="ui active dimmer">
                <div className="ui loader" />
            </div>
        );
    } else {
        return (
            <div className={`menu-configurator ${items.length < 4 ? `items_count-${items.length}` : '' }`}>
                <div className="menu-configurator__header">
                    <h3 className="mb-4">{staticTexts.header}</h3>
                </div>
                <div className="menu-configurator__container bg-white mb-4">
                    <div className="menu-configurator__body">
                        <ConfiguratorTabs tabs={tabs}/>
                        <div className="pb-3">
                            <div className="menu-configurator__menu_label">
                                <h3 className="mt-4">{menuDescription}</h3>
                            </div>
                            <div className="menu-configurator__items">
                                {items.map((item) => <MenuItem key={item.id} item={item}/> )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="menu-configurator__footer">
                    <button data-modal="#modal-menu-configurator" type="button" className="btn btn--secondary mr-2">{staticTexts.button.close}</button>
                    <button disabled={canFinish ? null : "disabled"} onClick={finishConfiguration} type="button" className={`btn btn--primary ${canFinish ? '' : 'disabled'} ml-2`}>{staticTexts.button.finish}</button>
                </div>
            </div>
        );
    }
});
